import { EAccountPlansType } from "../../Enum/EAccountPlansType"
import { EBillingPeriodType } from "../../Enum/EBillingPeriodType"
import { ECommercialOriginType } from "../../Enum/ECommercialOriginType"
import { SubscriptionPaymentEntity } from "./SubscriptionPaymentEntity"

export class SubscriptionEntity {
  id: number

  userId: string

  companyEntityId: number

  planEntityId?: number

  planPeriodEntityId?: number

  currentPeriodType?: EBillingPeriodType

  providerName?: string

  eAccountPlansType: EAccountPlansType

  currentChargeAmount: number

  commercialOriginType: ECommercialOriginType

  commercialReferralCode?: string

  status: string

  statusDetail?: string

  startDate?: Date

  endDate?: Date

  nextPaymentDate?: Date

  lastPaymentDate?: Date

  lastPaymentId?: string

  lastPaymentStatus?: string

  cancelledAt?: Date

  isDelinquent: boolean

  createdAt: Date

  updatedAt: Date

  subscriptionPaymentEntity: SubscriptionPaymentEntity[]

  constructor(data: Partial<SubscriptionEntity>) {
    this.id = data.id ?? 0

    this.userId = data.userId ?? ""

    this.companyEntityId = data.companyEntityId ?? 0

    this.planEntityId = data.planEntityId

    this.planPeriodEntityId = data.planPeriodEntityId

    this.currentPeriodType = data.currentPeriodType

    this.providerName = data.providerName

    this.eAccountPlansType = data.eAccountPlansType ?? EAccountPlansType.None

    this.currentChargeAmount = data.currentChargeAmount ?? 0

    this.commercialOriginType = data.commercialOriginType ?? ECommercialOriginType.Undefined

    this.commercialReferralCode = data.commercialReferralCode

    this.status = data.status ?? "pending"

    this.statusDetail = data.statusDetail

    this.subscriptionPaymentEntity = data.subscriptionPaymentEntity?.map((e) => new SubscriptionPaymentEntity(e)) ?? []

    this.startDate = data.startDate ? new Date(data.startDate) : undefined

    this.endDate = data.endDate ? new Date(data.endDate) : undefined

    this.nextPaymentDate = data.nextPaymentDate ? new Date(data.nextPaymentDate) : undefined

    this.lastPaymentDate = data.lastPaymentDate ? new Date(data.lastPaymentDate) : undefined

    this.lastPaymentId = data.lastPaymentId

    this.lastPaymentStatus = data.lastPaymentStatus

    this.cancelledAt = data.cancelledAt ? new Date(data.cancelledAt) : undefined

    this.isDelinquent = data.isDelinquent ?? false

    this.createdAt = data.createdAt ? new Date(data.createdAt) : new Date()

    this.updatedAt = data.updatedAt ? new Date(data.updatedAt) : new Date()
  }

  isFree() {
    return this.eAccountPlansType === EAccountPlansType.None
  }

  isActive() {
    return this.status === "authorized"
  }

  isCancelled() {
    return this.status === "cancelled"
  }

  needsPayment() {
    return this.status === "payment_required"
  }
}
